import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { WorkplaceGridObject } from '@it2go/types';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../../services/workplace.service';
import { map } from 'rxjs/operators';

interface State {
    workplaces: WorkplaceGridObject | null,
}

const defaultState: State = {
    workplaces: null,
};

@Injectable()
export class WorkplaceSelectStore extends ComponentStoreFactory<State> {

    items$ = this.data.workplaces$.pipe(map((it) => it?.['items'] || []));

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService));
    }

}
